import React, { useMemo } from "react";
import { TrendingUp, Activity, Users2, Target } from "lucide-react";
import { useSimulator } from "../Simulator/SimulatorStore";

type Stat = {
  label: string;
  value: string;
  icon: React.ReactNode;
  accentClass: string; // color for icon/accent
};

export default function StatsCards() {
  const { global, policiesPerDay, avgCycleTimeDays } = useSimulator();
  const inputsZero =
    global.dailyLeadVolume === 0 &&
    global.leadQuality === 0 &&
    global.baseConversionRate === 0 &&
    global.cycleTimeImpact === 0;
  const stats = useMemo<Stat[]>(() => {
    const days = 30;
    const totalLeads = global.dailyLeadVolume * days;
    const totalPolicies = Math.round(policiesPerDay * days);
    const convRate = totalLeads > 0 ? (totalPolicies / totalLeads) * 100 : 0;
    return [
      { label: "Conversion Rate", value: `${convRate.toFixed(1)}%`, icon: <TrendingUp className="w-5 h-5" />, accentClass: "text-red-500" },
      { label: "Avg Cycle Time", value: inputsZero ? "0.0 days" : `${avgCycleTimeDays.toFixed(1)} days`, icon: <Activity className="w-5 h-5" />, accentClass: "text-blue-500" },
      { label: "Total Leads", value: `${totalLeads}`, icon: <Users2 className="w-5 h-5" />, accentClass: "text-purple-500" },
      { label: "Policies Written", value: `${totalPolicies}`, icon: <Target className="w-5 h-5" />, accentClass: "text-green-600" },
    ];
  }, [avgCycleTimeDays, global.baseConversionRate, global.cycleTimeImpact, global.dailyLeadVolume, global.leadQuality, inputsZero, policiesPerDay]);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <div key={s.label} className="bg-white rounded-lg shadow p-6 flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">{s.label}</p>
            <p className={`text-3xl font-bold ${s.label === "Conversion Rate" ? "text-red-600" : "text-gray-900"}`}>{s.value}</p>
          </div>
          <div className={`rounded-lg bg-gray-50 border border-gray-100 p-2 ${s.accentClass}`}>{s.icon}</div>
        </div>
      ))}
    </div>
  );
}
